import { getCurrentApp } from "core/appRegistry";
import { getLocalizedPath } from "helpers/getLocalizedPath";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

const Link = ({ to, hideCurrentApp = false, localize = true, ...rest }) => {
  const currentApp =
    useSelector((state) => state.app.currentApp) || getCurrentApp()?.key || "";

  const getPath = () => {
    if (typeof to === "string" && /^https?:\/\//i.test(to)) {
      return to;
    }
    const pathWithApp = hideCurrentApp ? to : `/${currentApp}${to}`;
    const localizedPath = localize
      ? getLocalizedPath(pathWithApp)
      : pathWithApp;
    return localizedPath;
  };

  return <RouterLink {...(to ? { to: getPath() } : {})} {...rest} />;
};
export default Link;
